import MapMarker from './MapMarker'

export default MapMarker
